/** 

=========================================================
* Vision UI PRO React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/vision-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com/)

* Design and Coded by Simmmple & Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Visionware.

*/

export const barChartData = [
  {
    name: 'Takedowns',
    data: [90, 70, 85, 100, 75, 95, 110],
  },
];

export const barChartOptions = {
  chart: {
    toolbar: {
      show: false,
    },
    type: 'bar',
  },
  tooltip: {
    style: {
      fontSize: '12px',
      fontFamily: 'Plus Jakarta Display',
    },
    theme: 'dark',
    onDatasetHover: {
      style: {
        fontSize: '12px',
        fontFamily: 'Plus Jakarta Display',
      },
    },
  },
  xaxis: {
    categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    show: true,
    labels: {
      show: true,
      style: {
        colors: '#A0AEC0',
        fontSize: '12px',
        fontFamily: 'Plus Jakarta Display',
      },
    },
    axisBorder: {
      show: false,
    },
    axisTicks: {
      show: false,
    },
  },
  yaxis: {
    show: true,
    color: '#A0AEC0',
    labels: {
      show: true,
      style: {
        colors: '#A0AEC0',
        fontSize: '12px',
        fontFamily: 'Plus Jakarta Display',
      },
    },
  },
  grid: {
    show: true,
    strokeDashArray: 5,
    borderColor: '#56577A',
    yaxis: {
      lines: {
        show: true,
      },
    },
    xaxis: {
      lines: {
        show: false,
      },
    },
  },
  fill: {
    type: 'gradient',
    gradient: {
      type: 'vertical',
      shadeIntensity: 1,
      opacityFrom: 0.7,
      opacityTo: 0.9,
      colorStops: [
        [
          {
            offset: 0,
            color: '#0075FF',
            opacity: 1,
          },
          {
            offset: 100,
            color: '#2CD9FF',
            opacity: 0.8,
          },
        ],
      ],
    },
  },
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    bar: {
      borderRadius: 8,
      columnWidth: '40px',
    },
  },
};
